import { environment } from "environments/environment";
import { IElementTypeMainSecondInfo, IKryptomonResponse, IKryptomonSubgraphQueryRes, Igenes, Ikryptomon, eElementType, eGender, eSpeciality } from "./kryptomons.interface"
import { IAnyKryptomonResponse } from "./kryptomons-any-nft.interface";

export const enrichDataForKryptomon = (kryptomon: Ikryptomon): Ikryptomon => {
    let result: Ikryptomon;
    let evolutionInfo = getEvolutionInfo(kryptomon);
    let hatchingInfo = getHatchingInfo(kryptomon);
    let trainedLevel = getTrainedLevel(kryptomon);

    result = {
        ...kryptomon,
        nextEvolution: evolutionInfo.nextEvolution,
        isReadyToEvolve: evolutionInfo.isReadyToEvolve,
        hatchingDate: hatchingInfo.hatchingDate,
        isReadyToHatch: hatchingInfo.isReadyToHatch,
        trainedLevel: trainedLevel
    }

    return result;

}

export const getEvolutionInfo = (kryptomon: IKryptomonResponse): { nextEvolution: Date, isReadyToEvolve: boolean } => {
    let nextEvolution: Date;
    let evolutionTime: number = evolutionTimes[kryptomon.status];
    if (kryptomon.isStarter) nextEvolution = new Date((parseInt(kryptomon.timeHatched) + (evolutionTime * 1000)));
    else nextEvolution = new Date((parseInt(kryptomon.timeHatched) + evolutionTime) * 1000);
    let isReadyToEvolve: boolean = nextEvolution < new Date() && kryptomon.status > 0 && kryptomon.status < 2;
    return { nextEvolution, isReadyToEvolve };
}

export const getHatchingInfo = (kryptomon: IKryptomonResponse): { hatchingDate: Date, isReadyToHatch: boolean } => {
    let hatchingDate: Date;
    let isReadyToHatch: boolean;
    let hatchingDateUnix: number = kryptomon.isStarter ? (parseInt(kryptomon.timeBorn) / 1000) + 180 : parseInt(kryptomon.timeBorn) + hatchingTime;
    hatchingDate = new Date((hatchingDateUnix + 20) * 1000);
    isReadyToHatch = hatchingDate < new Date() && kryptomon.status == 0;
    //TODO isReadyToHatch
    return { hatchingDate, isReadyToHatch }

}

export const getTrainedLevel = (kryptomon: IKryptomonResponse): number => {
    let trainedLevel: number = Math.round(
        (kryptomon.gameMetadata.attackLevel +
            kryptomon.gameMetadata.defenseLevel +
            kryptomon.gameMetadata.hpLevel +
            kryptomon.gameMetadata.mainFamilyTalentLevel +
            kryptomon.gameMetadata.secondaryFamilyTalentLevel)
        / 5)
    if (isNaN(trainedLevel)) {
        trainedLevel = 0;
    }
    return trainedLevel;
}

export const getKryptomonFEPic = (status: number, elementType: string, speciality: string, tokenId: string, unfreezable?: string): string => {
    let pic: string;
    switch (status + '') {
        case '0':
            pic = unfreezable == '0' || !unfreezable ? `./assets/img/${elementType}/${speciality.toLowerCase()}.png` : `./assets/img/top_special/${elementType}/${speciality.toLowerCase()}.png`
            break;
        case '1':
            pic = `${environment.apiImages}images/kryptomons/png/kmon_${tokenId}_png.png`
            break;
        case '2':
            pic = `${environment.apiImages}images/kryptomons-junior/png/kmon_${tokenId}_png.png`
            break;
        case '3': //RIGHT NOW 3 IS EQUAL 2
            pic = `${environment.apiImages}images/kryptomons-junior/png/kmon_${tokenId}_png.png`
            break;
        default:
            break;
    }
    return pic;
}

export const parseFromNFTtoKryptomon = (nftKryptomons: IAnyKryptomonResponse): Ikryptomon[] => {
    let parsedKryptomon: Ikryptomon[] = [];
    nftKryptomons.data.forEach(k => {
        let mainSecondElementInfo = getMainSecondElementInfo(k.nft.data.kryptomon.genes);
        parsedKryptomon.push(
            {
                extraMarketData: {
                    tokenId: k.nft.tokenId,
                    activities: k.activities,
                    breedingCount: k.nft.data.kryptomon.breedingCount,
                    breedingOrder: k.breedingOrder,
                    breedingsLeft: k.nft.data.kryptomon.breedingsLeft,
                    owner: { address: k.nft.owner },
                    timeCanBreed: k.nft.data.kryptomon.timeCanBreed
                },
                orders: k.order?.id ? [{
                    id: k.order.id,
                    tokenId: k.order.tokenId,
                    price: k.order.priceUSD + '',
                    createdAt: k.order.createdAt + '',
                    expiresAt: k.order.expiresAt + '',
                    nftAddress: '', //TO CHECK IF ITS AN ISSUE
                    status: k.order.status,
                    owner: k.order.owner,
                    buyer: k.order.buyer,
                    paymentToken: k.order.paymentToken,
                    nft: { contractAddress: k.order.contractAddress },
                    updatedAt: k.order.updatedAt + ''
                }] : null,
                bids: null,
                tokenId: k.nft.tokenId,
                matronId: k.nft.data.kryptomon.matronId,
                sireId: k.nft.data.kryptomon.sireId,
                timeBorn: k.nft.data.kryptomon.timeBorn,
                extraData: k.nft.data.kryptomon.extraData,
                genesV1: k.nft.data.kryptomon.genes,
                name: k.nft.name,
                elementType: k.nft.data.kryptomon.elementType,
                // elementTalent: (
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementType.toLocaleLowerCase()]) *
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementType.toLocaleLowerCase() + 'Talent'])) + '',
                // elementPercentage: (
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementType.toLocaleLowerCase()]) *
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementType.toLocaleLowerCase() + 'Talent'])) + '',
                // elementTypeSecond: eElementType[k.nft.data.kryptomon.elementTypeSecond],
                // elementTalentSecond: (
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementTypeSecond.toLocaleLowerCase()]) *
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementTypeSecond.toLocaleLowerCase() + 'Talent'])) + '',
                // elementPercentageSecond: (
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementTypeSecond.toLocaleLowerCase()]) *
                //     parseInt(k.nft.data.kryptomon.genes[k.nft.data.kryptomon.elementTypeSecond.toLocaleLowerCase() + 'Talent'])) + '',
                elementTalent: mainSecondElementInfo.elementTalent,
                elementPercentage: mainSecondElementInfo.elementPercentage,
                elementTypeSecond: eElementType[k.nft.data.kryptomon.elementTypeSecond],
                elementTalentSecond: mainSecondElementInfo.elementTalentSecond,
                elementPercentageSecond: mainSecondElementInfo.elementPercentageSecond,
                speciality: eSpeciality[k.nft.data.kryptomon.speciality],
                id: k.nft.id,
                genes: k.nft.data.kryptomon.genes,
                status: parseInt(k.nft.data.kryptomon.status),
                timeHatched: k.nft.data.kryptomon.timeHatched,
                rental: undefined,//TO CHECK IF ITS AN ISSUE
                isStarter: false,
                ranking: parseInt(k.nft.data.kryptomon.ranking),
                type: "owned",
                gameMetadata: k.nft.data.kryptomon.gameMetadata
            }
        );
    });
    return parsedKryptomon;
}

export const getGender = (kryptomon: Ikryptomon): eGender => {
    if (kryptomon) return parseInt(kryptomon.genes.sex, 10) <= 5 ? eGender.female : eGender.male
    else return null;
}

interface IKryptomonExtraData {
    nextEvolution: Date
    isReadyToEvolve: boolean
    hatchingDate: Date
    isReadyToHatch: boolean
    trainedLevel: number
}

const hatchingTime = 259200;// 30; //TO CHECK

const evolutionTimes = [
    259200, //3 days
    2629743, //1 month
    63113852, //24 months
    94670778 //36 months
];

export const mapGenes = (genesRes: number[]): Igenes => {
    let genes: Igenes = <Igenes>{};
    let genesOrder: string[] = [
        'fire',
        'fireTalent',
        'water',
        'waterTalent',
        'ice',
        'iceTalent',
        'ground',
        'groundTalent',
        'air',
        'airTalent',
        'electro',
        'electroTalent',
        'ghost',
        'ghostTalent',
        'grass',
        'grassTalent',
        'color',
        'sex',
        'generalTalent',
        'attack',
        'defense',
        'special',
        'xFactor',
        'growthTalentFactor',
        'constitution',
        'healthPoints',
        'speed',
        'affections',
        'crazyness',
        'instinct',
        'hunger',
        'laziness',
        'brave',
        'smart',
        'bodySize',
        'ego',
        'skinType',
        'generation',
    ];
    genesOrder.forEach((g, i) => {
        genes[g] = genesRes[i] + ''
    });
    return genes;
}

export const getMainSecondElementInfo = (genes: Igenes): IElementTypeMainSecondInfo => {
    // let talents: { [element in eElementType]: number };
    let talents: { elementType: eElementType, value: number }[] = [];
    let maxElementTalent: { element: eElementType, value: number };
    let totalTalent = 0;
    // for (let element in eElementType) {
    //     talents[element] = parseInt(genes[element.toLowerCase()]) * parseInt(genes[element.toLowerCase() + 'Talent']);
    // }
    // for (let element in talents) {
    //     let _talentValue = talents[element];
    //     totalTalent = totalTalent + _talentValue;
    //     if (!maxElementTalent || maxElementTalent.value < _talentValue) maxElementTalent = {
    //         element: eElementType[element],
    //         value: _talentValue
    //     }
    // }
    for (let element in eElementType) {
        talents.push({
            elementType: eElementType[element],
            value: parseInt(genes[element.toLowerCase()]) * parseInt(genes[element.toLowerCase() + 'Talent'])
        });
    }
    talents.sort((a, b) => b.value - a.value);
    totalTalent = talents.reduce((prev, curr) => prev + curr.value, 0);
    return {
        elementType: talents[0].elementType,
        elementTalent: talents[0].value + '',
        elementTypeSecond: talents[1].elementType,
        elementTalentSecond: talents[1].value + '',
        elementPercentage: Math.round(talents[0].value * 10000 / totalTalent) + '',
        elementPercentageSecond: Math.round(talents[1].value * 10000 / totalTalent) + ''
    }

}

export const getElementAttack = (genes: Igenes): { [element in eElementType]: number } => {
    let result: { [element in eElementType]: number } = <{ [element in eElementType]: number }>{};
    for (let element in eElementType) {
        let el = parseInt(genes[element.toLowerCase()]);
        let elTalent = parseInt(genes[element.toLowerCase() + 'Talent']);
        result[element] = Math.round(el * elTalent / 100);
    }
    return result;
}